import { InputMask as ReactInputMask } from "@react-input/mask";
import clsx from "clsx";

import type { InputProps } from "../../../interfaces/input";
import { LoadingSkeleton } from "../../LoadingSkeleton";
import { InputError } from "../InputError";

import type { JSX } from "react";

const getMaskFromInputType = (type: string | undefined) => {
  switch (type) {
    case "cpf":
      return "###.###.###-##";
    case "cnpj":
      return "##.###.###/####-##";
    case "date":
      return "##/##/####";
    case "hour":
      return "##:##";
    case "cep":
      return "#####-###";
    case "cardNumber":
      return "#### #### #### ####";
    case "cardSecurityCode":
      return "###";
    case "monthYearDate":
      return "##/##";
    default:
      return undefined;
  }
};

export const InputMask = ({
  field,
  label,
  className,
  errorMessage,
  type,
  loadingValue,
  ...attributes
}: InputProps): JSX.Element => {
  const mask = getMaskFromInputType(type);

  return (
    <div className={clsx("flex flex-col", className)}>
      {label && (
        <label className={clsx("mb-1 lg:mb-0.5", attributes.disabled && "opacity-50")} htmlFor={field}>
          <b>{label}</b>
        </label>
      )}
      {loadingValue ? (
        <LoadingSkeleton kind="input" />
      ) : (
        <ReactInputMask
          {...attributes}
          mask={mask}
          replacement={{ "#": /\d/ }}
          className={clsx({ "outline-feedback-error": errorMessage })}
          id={field}
          name={field}
        />
      )}
      <InputError message={errorMessage} />
    </div>
  );
};
